import React, { Component } from 'react';
import LoginForm from './components/LoginForm';
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import { authorize } from '../sagas/actions';

class Login extends Component {
  doLogin = ({ username, password }) => {
    this.props.dispatch(authorize(username, password));
  }

  render() {
    const { token } = this.props;
    if (token) {
      return <Redirect to="/" />;
    }
    return (
      <div style={{paddingTop: 300, paddingBottom: 300}}>
        <LoginForm doLogin={this.doLogin}></LoginForm>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  token: state.auth.token
});

export default connect(mapStateToProps)(Login);




// WEBPACK FOOTER //
// ./src/login/Login.jsx